import { COLORS } from 'styles/colors'

type FatnessCategory = {
	label: string
	color: string
	value: number
}

const FATNESS_PRESENTATION: Record<
	string,
	{ label: string; color: string; order: number }
> = {
	нормальная: { label: 'В норме', color: COLORS.main, order: 0 },
	'в норме': { label: 'В норме', color: COLORS.main, order: 0 },
	'с отклонением': {
		label: 'С отклонением',
		color: COLORS.health,
		order: 1,
	},
	'с ожирением': {
		label: 'С ожирением',
		color: COLORS.error,
		order: 2,
	},
	'с истощением': {
		label: 'С истощением',
		color: COLORS.black,
		order: 3,
	},
}

export const normalizeFatnessCategories = <T extends FatnessCategory>(
	items: T[] = [],
) =>
	items
		.map(item => {
			const presentation = FATNESS_PRESENTATION[item.label.trim().toLowerCase()]

			return presentation
				? {
						...item,
						label: presentation.label,
						color: presentation.color,
						order: presentation.order,
					}
				: { ...item, order: Number.MAX_SAFE_INTEGER }
		})
		.sort((left, right) => left.order - right.order)
		.map(({ order, ...item }) => item)
